module.exports = __webpack_public_path__ + "img/icon_fn_bluetooth.9f368d7e.svg";